<template>
  <div>
    <b-input-group class="bg-transparent">
      <b-input-group-prepend
        :style="size != 'sm' ? 'height:38px' : 'height:31px'"
      >
        <b-form-datepicker
          v-model="date"
          trim
          button-only
          button-variant=""
          :date-format-options="{
            year: 'numeric',
            day: '2-digit',
            month: '2-digit'
          }"
          :state="errors ? (errors.length == 0 ? null : false) : null"
          :min="min ? min : null"
          :max="max ? max : null"
          :readonly="readonly ? readonly : null"
          :disabled="disabled ? disabled : false"
          boundary="viewport"
          :no-flip="true"
          :popper-opts="{
            positionFixed: true
          }"
          calendar-width="230px"
          :size="size"
          class="border datepicker-button rounded-left"
          :date-disabled-fn="dateDisabledFn ? dateDisabledFn : null"
        >
          <template #button-content>
            <div class="d-flex align-items-center">
              <i
                class="fa fa-calendar-alt"
                style="font-size: 20px; color: #646A7A;"
                aria-hidden="true"
              ></i>
            </div>
          </template>
        </b-form-datepicker>
      </b-input-group-prepend>
      <b-form-input
        v-model="formattedValue"
        type="text"
        :placeholder="placeholder ? placeholder : 'MM/DD/YYYY'"
        autocomplete="off"
        :state="errors ? (errors.length == 0 ? null : false) : null"
        :readonly="readonly ? readonly : null"
        :disabled="disabled ? disabled : false"
        v-facade="'##/##/####'"
        :style="inputWidth ? `width:${inputWidth}px` : ''"
        :size="size"
        @blur="$emit('handleBlur', $event)"
      ></b-form-input>
    </b-input-group>
  </div>
</template>

<script>
import {
  formatDateOnlyMysql,
  formatDateOnly,
  checkDateFormat
} from "../../helpers/date";
export default {
  name: "DatePicker",
  props: [
    "placeholder",
    "value",
    "errors",
    "max",
    "min",
    "readonly",
    "disabled",
    "inputWidth",
    "size",
    "dateDisabledFn"
  ],
  computed: {
    date: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      }
    },
    formattedValue: {
      get() {
        if (checkDateFormat(this.value, "YYYY-MM-DD")) {
          return formatDateOnly(this.value);
        } else {
          return this.value;
        }
      },
      set(newValue) {
        if (checkDateFormat(newValue, "MM/DD/YYYY")) {
          this.$emit("input", formatDateOnlyMysql(newValue));
        } else {
          this.$emit("input", newValue);
        }
      }
    }
  }
};
</script>

<style>
.datepicker-button:hover {
  background-color: #a7aebf;
}
</style>
